export default __webpack_public_path__ + "static/media/191.8f2f7bae.png";